"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetState = exports.fetchUserPointsWithExpiry = exports.fetchUserPoints = exports.redeemFromPoints = exports.getTransactionHistory = exports.fetchUserTokens = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/ledger/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var action_type_util_1 = require("../../../redux/action-type.util");
var actions_1 = require("../app/actions");
var fetchUserTokens = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.USER_TOKENS,
                    payload: services_1.LedgerService.getUserTokens()
                }).catch(function (error) {
                    console.error(error);
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.fetchUserTokens = fetchUserTokens;
var getTransactionHistory = function (params) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_1.GET_TRANSACTION_HISTORY,
                        payload: services_1.LedgerService.getTransactionHistory(params)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getTransactionHistory = getTransactionHistory;
var redeemFromPoints = function (payload, successCallback, failedCallback) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error_2;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                _a = dispatch;
                _b = {
                    type: types_1.REDEEM_FROM_POINTS
                };
                return [4, services_1.LedgerService.redeemFromPoints(payload)];
            case 1:
                _a.apply(void 0, [(_b.payload = _c.sent(),
                        _b)]);
                successCallback();
                return [3, 3];
            case 2:
                error_2 = _c.sent();
                console.error(error_2);
                failedCallback(error_2);
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_1.REDEEM_FROM_POINTS),
                    payload: error_2
                });
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.redeemFromPoints = redeemFromPoints;
var fetchUserPoints = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, dispatch({
                    type: types_1.USER_BALANCE,
                    payload: services_1.LedgerService.getLoyaltyPointsBalance()
                }).catch(function (error) {
                    console.error(error);
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); }; };
exports.fetchUserPoints = fetchUserPoints;
var fetchUserPointsWithExpiry = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var balance, pointsExpiring, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4, services_1.LedgerService.getLoyaltyPointsBalance()];
            case 1:
                balance = _a.sent();
                return [4, services_1.LedgerService.getLoyaltyPointsExpiring()];
            case 2:
                pointsExpiring = _a.sent();
                balance.expiryAmount = pointsExpiring;
                dispatch({
                    type: types_1.USER_BALANCE_EXPIRY,
                    payload: balance
                });
                return [3, 4];
            case 3:
                error_3 = _a.sent();
                console.error(error_3);
                return [3, 4];
            case 4: return [2];
        }
    });
}); }; };
exports.fetchUserPointsWithExpiry = fetchUserPointsWithExpiry;
var resetState = function () { return function (dispatch) {
    dispatch((0, actions_1.clearMessages)());
    dispatch({
        type: types_1.RESET_STATE,
        payload: null
    });
}; };
exports.resetState = resetState;
//# sourceMappingURL=actions.js.map